import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';

const adEDM = edmCampaign.types.resolve('Model.ResponsiveAd');
const adResource = new adEDM.ResourceIdentifier();

const updateData = data => adResource.bulkUpdate.bind(adResource)(data);

const viewModelToModelForAdToDelete = ({ adsViewModel, campaign, adGroup }) => {
  const adViewModel = [];

  _.each(adsViewModel, (ad) => {
    const fields = {
      'Client Id': '0', // `${ad.uid}`,
      Id: ad.Id,
      Status: 'Deleted',
      Campaign: _.pick(campaign, 'Id'),
      AdGroup: _.pick(adGroup, 'Id'),
    };

    adViewModel.push(fields);
  });

  return adViewModel;
};

export const deleteAd = ({ ad, campaign, adGroup }) => {
  const deleteAds = viewModelToModelForAdToDelete({ adsViewModel: ad, campaign, adGroup });

  return updateData(deleteAds).then(result => result, err => err);
};

